import { Component, ElementRef, OnInit } from '@angular/core';
import { ApiService, AuthService, DialogService, FieldService, MetadataService, ModalService, TranslatorService } from '../../../services';
import { CalendarService } from '../../../services/calendar.service';
import { UscStoreService } from '../../../services/usc-store/usc-store.service';
import { DialogComponent } from '../../common/dialog/dialog.component';
import { UscDialogComponent } from '../usc-dialog/usc-dialog.component';

@Component({
    selector: 'sn-usc-todays-goal',
    templateUrl: './usc-todays-goal.component.html',
    styleUrls: ['./usc-todays-goal.component.css']
})
export class UscTodaysGoalComponent implements OnInit {

    action_plan: any = {};
    daily_goal: any = {};
	daily_goal_fields: any[];

    isDraft: boolean = true;
    days_remaining: number = 0;
    full_name: string = "";
    current_date: string = "";
    public is_daily_goal_loaded: boolean = false;
    public is_saving_todays_goal: boolean = false;

    // payout estimator 2.0
	public business_drivers: any[] = [];
	public action_plan_values: any = {
		postpaid_basic: { driver: "postpaid_basic", is_goal_editable: true },
		postpaid_everyday: { driver: "postpaid_everyday", is_goal_editable: true },
		postpaid_even_better: { driver: "postpaid_even_better", is_goal_editable: true },
		postpaid: { driver: "postpaid_handset_volume", is_goal_editable: false },
		hsi: { driver: "hsi", is_goal_editable: true },
		prepaid: { driver: "prepaid", is_goal_editable: true },
		connected_devices: { driver: "connected_devices", is_goal_editable: true },
		// other_volume: { driver: "other_volume", is_goal_editable: false },
		bir: { driver: "bir", is_goal_editable: true },
		accessories_revenue: { driver: "accessories_revenue", is_goal_editable: true },
		other_revenue: { driver: "other_revenue", is_goal_editable: true },
		upgrades_basic: { driver: "upgrades_basic", is_goal_editable: true },
		upgrades_everyday: { driver: "upgrades_everyday", is_goal_editable: true },
		upgrades_even_better: { driver: "upgrades_even_better", is_goal_editable: true },
		upgrades: { driver: "upgrades", is_goal_editable: false },
		high_msrp_accessories: { driver: "high_msrp_accessories", is_goal_editable: true },
		// device_trade_ins: { driver: "device_trade_ins", is_goal_editable: true }
	}
    
    pp_basic_p2w_daily_goal: any = 0;
    pp_everyday_p2w_daily_goal: any = 0;
    pp_even_better_p2w_daily_goal: any = 0;
    pp_p2w_daily_goal: any = 0;
    hsi_p2w_daily_goal: any = 0;
    prepaid_p2w_daily_goal: any = 0;
    cd_p2w_daily_goal: any = 0;
    other_p2w_daily_goal: any = 0;
    revenue_p2w_daily_goal: any = 0;
    ar_p2w_daily_goal: any = 0;
    or_p2w_daily_goal: any = 0;
    bir_p2w_daily_goal: any = 0;
    ug_basic_p2w_daily_goal: any = 0;
    ug_everyday_p2w_daily_goal: any = 0;
    ug_even_better_p2w_daily_goal: any = 0;
    upgrades_p2w_daily_goal: any = 0;
    hma_p2w_daily_goal: any = 0;
    dti_p2w_daily_goal: any = 0;

    constructor(
        public elementRef: ElementRef,
		public dialogService: DialogService,
        public uscStoreService: UscStoreService,
		public fieldService: FieldService,
		public metaDataService: MetadataService,
		public apiService: ApiService,
		public modalService: ModalService,
		public calendarService: CalendarService,
        public translatorService: TranslatorService,
        public authService: AuthService,
    ) { }

    ngAfterViewInit(){
        //this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor = '#f0f0f0';       // keep this here but commented as a sample code for setting background color 
    }
    
    ngOnInit() {
        var action_user = this.authService.getActive();
        if (this.uscStoreService.isUSCellAgent() && action_user.title != 'Manager') action_user = null;
        this.uscStoreService.getThisMonthActionPlans(action_user).subscribe(
            result => {
                this.action_plan = result;
                // this month's action plan has not been approved
                if (this.action_plan == null || this.action_plan.cs_status == this.uscStoreService.action_plan_status_draft) {
                    this.uscStoreService.setCurrentView(this.uscStoreService.view_p2w_this_action_plan);
                } else {
                    // get daily goal field config
                    this.metaDataService.getFormViewMetaData(this.uscStoreService.view_p2w_daily_goal, {}).subscribe(
                        result => {
                            this.daily_goal_fields = result.meta_data.view_fields;
                        },
                        err => { console.log(err) }
                    )                    
                    for (const p in this.action_plan) {
                        if (p.indexOf("mtd_") >= 0) {
                            if (this.action_plan[p] == null) this.action_plan[p] = 0;
                        }
                    }
                    this.calculateMTDResults();                
                    // get daily goal
                    this.getDailyGoal();
                }
            }
        );
    }

    public getDailyGoal() {
        var action_plan = this.action_plan;
        this.uscStoreService.getTodaysGoal(true).subscribe(
            result => {
                this.daily_goal = result;
                if (this.daily_goal) {
                    this.isDraft = this.daily_goal.cs_status == this.uscStoreService.daily_goal_status_draft;
                    if (this.isDraft) {
                        this.days_remaining = action_plan.cs_days_scheduled - action_plan.days_worked;
                        this.initDailyGoalValues();
                        this.preprocessP2WFieldsToCurrency();
                        this.is_daily_goal_loaded = true;
                        var msgList = [];				 
                        msgList.push("Please note, you must submit your 'Today's Goals' before you can proceed into SalesNOW.");
                        var ngbModalRef = this.modalService.openContent(
                            DialogComponent,
                            { dlgType: this.dialogService.dlg_type_confirmation, dlg_config: { msgList: msgList }},
                            { backdrop: 'static', keyboard: false }
                        );
                        ngbModalRef.result.then(
                            (result) => { ngbModalRef.dismiss(); },
                            (reason) => { ngbModalRef.dismiss(); }
                        );        
                    }
                } else {
                    this.daily_goal = {};
                    this.uscStoreService.createTodaysGoal().subscribe(goal => {
                        this.daily_goal = goal;
                        this.days_remaining = this.action_plan.cs_days_scheduled - this.action_plan.days_worked;
                        this.initializeTodaysGoal();
                        this.initDailyGoalValues();
                        this.preprocessP2WFieldsToCurrency();
                        this.saveDailyGoal();
                    })
                }
            }
        )
    }

	calculateMTDResults() {
        this.action_plan.cs_p2w_revenue = parseInt(this.action_plan.cs_p2w_accessories_revenue) + parseInt(this.action_plan.cs_p2w_other_revenue);
        this.action_plan.mtd_revenue = parseInt(this.action_plan.mtd_accessories_revenue) + parseInt(this.action_plan.mtd_other_revenue);
		// daily goals
		var days_scheduled = this.action_plan.cs_days_scheduled; 
        if (days_scheduled && days_scheduled > 0) {
            this.pp_basic_p2w_daily_goal = this.action_plan.cs_p2w_postpaid_basic / days_scheduled;
            this.pp_everyday_p2w_daily_goal = this.action_plan.cs_p2w_postpaid_everyday / days_scheduled;
            this.pp_even_better_p2w_daily_goal = this.action_plan.cs_p2w_postpaid_even_better / days_scheduled;
            this.pp_p2w_daily_goal = this.action_plan.cs_p2w_postpaid / days_scheduled;
            this.hsi_p2w_daily_goal = this.action_plan.cs_p2w_hsi / days_scheduled;
            this.prepaid_p2w_daily_goal = this.action_plan.cs_p2w_prepaid / days_scheduled;
            this.cd_p2w_daily_goal = this.action_plan.cs_p2w_connected_devices / days_scheduled;
            this.other_p2w_daily_goal = this.action_plan.cs_p2w_other / days_scheduled;
            this.bir_p2w_daily_goal = this.action_plan.cs_p2w_bir / days_scheduled;
            this.ar_p2w_daily_goal = this.action_plan.cs_p2w_accessories_revenue / days_scheduled;
            this.or_p2w_daily_goal = this.action_plan.cs_p2w_other_revenue / days_scheduled;
            this.revenue_p2w_daily_goal = this.ar_p2w_daily_goal + this.or_p2w_daily_goal;
            this.ug_basic_p2w_daily_goal = this.action_plan.cs_p2w_upgrades_basic / days_scheduled;
            this.ug_everyday_p2w_daily_goal = this.action_plan.cs_p2w_upgrades_everyday / days_scheduled;
            this.ug_even_better_p2w_daily_goal = this.action_plan.cs_p2w_upgrades_even_better / days_scheduled;
            this.upgrades_p2w_daily_goal = this.action_plan.cs_p2w_upgrades / days_scheduled;
            this.hma_p2w_daily_goal = this.action_plan.cs_p2w_high_acc / days_scheduled;
            // this.dti_p2w_daily_goal = this.action_plan.cs_p2w_device_trade_ins / days_scheduled;
        }

        // label
        this.action_plan_values.postpaid_basic.label = "Postpaid - Basic";
        this.action_plan_values.postpaid_everyday.label = "Postpaid - Everyday";
        this.action_plan_values.postpaid_even_better.label = "Postpaid - Even Better";
        this.action_plan_values.postpaid.label = "Total Postpaid";
        this.action_plan_values.hsi.label = "HSI";
        this.action_plan_values.prepaid.label = "Prepaid";
        this.action_plan_values.connected_devices.label = "Connected Devices";
        // this.action_plan_values.other_volume.label = "Other Volume";
        this.action_plan_values.bir.label = "BiR";
        this.action_plan_values.accessories_revenue.label = "Accessories Revenue ($)";
        this.action_plan_values.other_revenue.label = "Other Revenue ($)";
        this.action_plan_values.upgrades_basic.label = "Upgrades - Basic";
        this.action_plan_values.upgrades_everyday.label = "Upgrades - Everyday";
        this.action_plan_values.upgrades_even_better.label = "Upgrades - Even Better";
        this.action_plan_values.upgrades.label = "Total Upgrades";
        this.action_plan_values.high_msrp_accessories.label = "High MSRP Accessories";
        // this.action_plan_values.device_trade_ins.label = "Device Trade Ins";
        // month_goals
        this.action_plan_values.postpaid_basic.month_goals          = parseInt(this.action_plan.cs_p2w_postpaid_basic);
        this.action_plan_values.postpaid_everyday.month_goals       = parseInt(this.action_plan.cs_p2w_postpaid_everyday);
        this.action_plan_values.postpaid_even_better.month_goals    = parseInt(this.action_plan.cs_p2w_postpaid_even_better);
        this.action_plan_values.postpaid.month_goals                = parseInt(this.action_plan.cs_p2w_postpaid);
        this.action_plan_values.hsi.month_goals                     = parseInt(this.action_plan.cs_p2w_hsi);
        this.action_plan_values.prepaid.month_goals                 = parseInt(this.action_plan.cs_p2w_prepaid);
        this.action_plan_values.connected_devices.month_goals       = parseInt(this.action_plan.cs_p2w_connected_devices);
        // this.action_plan_values.other_volume.month_goals            = parseInt(this.action_plan.cs_p2w_other);
        this.action_plan_values.bir.month_goals                     = parseInt(this.action_plan.cs_p2w_bir);
        this.action_plan_values.accessories_revenue.month_goals     = parseInt(this.action_plan.cs_p2w_accessories_revenue);
        this.action_plan_values.other_revenue.month_goals           = parseInt(this.action_plan.cs_p2w_other_revenue);
        this.action_plan_values.upgrades_basic.month_goals          = parseInt(this.action_plan.cs_p2w_upgrades_basic);
        this.action_plan_values.upgrades_everyday.month_goals       = parseInt(this.action_plan.cs_p2w_upgrades_everyday);
        this.action_plan_values.upgrades_even_better.month_goals    = parseInt(this.action_plan.cs_p2w_upgrades_even_better);
        this.action_plan_values.upgrades.month_goals                = parseInt(this.action_plan.cs_p2w_upgrades);
        this.action_plan_values.high_msrp_accessories.month_goals   = parseInt(this.action_plan.cs_p2w_high_acc);
        // this.action_plan_values.device_trade_ins.month_goals        = parseInt(this.action_plan.cs_p2w_device_trade_ins);
        // mtd_actual
        this.action_plan_values.postpaid_basic.mtd_actual = this.action_plan.mtd_postpaid_basic;
        this.action_plan_values.postpaid_everyday.mtd_actual = this.action_plan.mtd_postpaid_everyday;
        this.action_plan_values.postpaid_even_better.mtd_actual = this.action_plan.mtd_postpaid_even_better;
        this.action_plan_values.postpaid.mtd_actual = this.action_plan.mtd_postpaid_handset_volume;
        this.action_plan_values.hsi.mtd_actual = this.action_plan.mtd_hsi;
        this.action_plan_values.prepaid.mtd_actual = this.action_plan.mtd_prepaid;
        this.action_plan_values.connected_devices.mtd_actual = this.action_plan.mtd_connected_devices;
        // this.action_plan_values.other_volume.mtd_actual = this.action_plan.mtd_other_volume;
        this.action_plan_values.bir.mtd_actual = this.action_plan.mtd_bir;
        this.action_plan_values.accessories_revenue.mtd_actual = this.action_plan.mtd_accessories_revenue;
        this.action_plan_values.other_revenue.mtd_actual = this.action_plan.mtd_other_revenue;
        this.action_plan_values.upgrades_basic.mtd_actual = this.action_plan.mtd_upgrades_basic;
        this.action_plan_values.upgrades_everyday.mtd_actual = this.action_plan.mtd_upgrades_everyday;
        this.action_plan_values.upgrades_even_better.mtd_actual = this.action_plan.mtd_upgrades_even_better;
        this.action_plan_values.upgrades.mtd_actual = this.action_plan.mtd_upgrades;
        this.action_plan_values.high_msrp_accessories.mtd_actual = this.action_plan.mtd_high_msrp_accessories;
        // this.action_plan_values.device_trade_ins.mtd_actual = this.action_plan.mtd_device_trade_ins;
        // daily_goal
        this.action_plan_values.postpaid_basic.daily_goal = Math.ceil(this.action_plan_values.postpaid_basic.month_goals / days_scheduled);
        this.action_plan_values.postpaid_everyday.daily_goal = Math.ceil(this.action_plan_values.postpaid_everyday.month_goals / days_scheduled);
        this.action_plan_values.postpaid_even_better.daily_goal = Math.ceil(this.action_plan_values.postpaid_even_better.month_goals / days_scheduled);
        this.action_plan_values.postpaid.daily_goal = this.action_plan_values.postpaid_basic.daily_goal + this.action_plan_values.postpaid_everyday.daily_goal + this.action_plan_values.postpaid_even_better.daily_goal;
        this.action_plan_values.hsi.daily_goal = Math.ceil(this.action_plan_values.hsi.month_goals / days_scheduled);
        this.action_plan_values.prepaid.daily_goal = Math.ceil(this.action_plan_values.prepaid.month_goals / days_scheduled);
        this.action_plan_values.connected_devices.daily_goal = Math.ceil(this.action_plan_values.connected_devices.month_goals / days_scheduled);
        // this.action_plan_values.other_volume.daily_goal = this.action_plan_values.hsi.daily_goal + this.action_plan_values.prepaid.daily_goal + this.action_plan_values.connected_devices.daily_goal;
        this.action_plan_values.accessories_revenue.daily_goal = Math.ceil(this.action_plan_values.accessories_revenue.month_goals / days_scheduled);
        this.action_plan_values.other_revenue.daily_goal = Math.ceil(this.action_plan_values.other_revenue.month_goals / days_scheduled);
        this.action_plan_values.bir.daily_goal = Math.ceil(this.action_plan_values.bir.month_goals / days_scheduled);
        this.action_plan_values.upgrades_basic.daily_goal = Math.ceil(this.action_plan_values.upgrades_basic.month_goals / days_scheduled);
        this.action_plan_values.upgrades_everyday.daily_goal = Math.ceil(this.action_plan_values.upgrades_everyday.month_goals / days_scheduled);
        this.action_plan_values.upgrades_even_better.daily_goal = Math.ceil(this.action_plan_values.upgrades_even_better.month_goals / days_scheduled);
        this.action_plan_values.upgrades.daily_goal = this.action_plan_values.upgrades_basic.daily_goal + this.action_plan_values.upgrades_everyday.daily_goal + this.action_plan_values.upgrades_even_better.daily_goal;
        this.action_plan_values.high_msrp_accessories.daily_goal = Math.ceil(this.action_plan_values.high_msrp_accessories.month_goals / days_scheduled);
        // this.action_plan_values.device_trade_ins.daily_goal = Math.ceil(this.action_plan_values.device_trade_ins.month_goals / days_scheduled);

        // generate business_drivers array for table
        this.business_drivers = [ ];
            this.business_drivers.push(this.action_plan_values.postpaid_basic);
            this.business_drivers.push(this.action_plan_values.postpaid_everyday);
            this.business_drivers.push(this.action_plan_values.postpaid_even_better);
            this.business_drivers.push(this.action_plan_values.postpaid);
            this.business_drivers.push(this.action_plan_values.hsi);
            this.business_drivers.push(this.action_plan_values.prepaid);
            this.business_drivers.push(this.action_plan_values.connected_devices);
            // this.business_drivers.push(// this.action_plan_values.other_volume);
            this.business_drivers.push(this.action_plan_values.accessories_revenue);
            if (!this.uscStoreService.isUSCellAgent()) this.business_drivers.push(this.action_plan_values.other_revenue);
            this.business_drivers.push(this.action_plan_values.bir);
            this.business_drivers.push(this.action_plan_values.upgrades_basic);
            this.business_drivers.push(this.action_plan_values.upgrades_everyday);
            this.business_drivers.push(this.action_plan_values.upgrades_even_better);
            this.business_drivers.push(this.action_plan_values.upgrades);
            if (!this.uscStoreService.isUSCellAgent()) this.business_drivers.push(this.action_plan_values.high_msrp_accessories);
            // this.action_plan_values.device_trade_ins
	}

    initDailyGoalValues() {
        // payout estimator 2.0
        // this.action_plan_values.postpaid_basic.todays_goal 			= this.daily_goal.cs_dg_postpaid_basic 			> this.action_plan_values.postpaid_basic.daily_goal ? this.daily_goal.cs_dg_postpaid_basic : this.action_plan_values.postpaid_basic.daily_goal + 1;
        // this.action_plan_values.postpaid_everyday.todays_goal 		= this.daily_goal.cs_dg_postpaid_everyday 		> this.action_plan_values.postpaid_everyday.daily_goal ? this.daily_goal.cs_dg_postpaid_basic : this.action_plan_values.postpaid_everyday.daily_goal + 1;
        // this.action_plan_values.postpaid_even_better.todays_goal 	= this.daily_goal.cs_dg_postpaid_even_better 	> this.action_plan_values.postpaid_even_better.daily_goal ? this.daily_goal.cs_dg_postpaid_basic : this.action_plan_values.postpaid_even_better.daily_goal + 1;
        // this.action_plan_values.postpaid.todays_goal 				= this.action_plan_values.postpaid_basic.todays_goal + this.action_plan_values.postpaid_everyday.todays_goal + this.action_plan_values.postpaid_even_better.todays_goal;
        // this.action_plan_values.upgrades_basic.todays_goal 			= this.daily_goal.cs_dg_upgrades_basic 			> this.action_plan_values.upgrades_basic.daily_goal ? this.daily_goal.cs_dg_postpaid_basic : this.action_plan_values.upgrades_basic.daily_goal + 1;
        // this.action_plan_values.upgrades_everyday.todays_goal 		= this.daily_goal.cs_dg_upgrades_everyday 		> this.action_plan_values.upgrades_everyday.daily_goal ? this.daily_goal.cs_dg_postpaid_basic : this.action_plan_values.upgrades_everyday.daily_goal + 1;
        // this.action_plan_values.upgrades_even_better.todays_goal 	= this.daily_goal.cs_dg_upgrades_even_better 	> this.action_plan_values.upgrades_even_better.daily_goal ? this.daily_goal.cs_dg_postpaid_basic : this.action_plan_values.upgrades_even_better.daily_goal + 1;
        // this.action_plan_values.upgrades.todays_goal 				= this.action_plan_values.upgrades_basic.todays_goal + this.action_plan_values.upgrades_everyday.todays_goal + this.action_plan_values.upgrades_even_better.todays_goal;
        
        this.action_plan_values.postpaid_basic.todays_goal 			= parseInt(this.daily_goal.cs_dg_postpaid_basic);
        this.action_plan_values.postpaid_everyday.todays_goal 		= parseInt(this.daily_goal.cs_dg_postpaid_everyday);
        this.action_plan_values.postpaid_even_better.todays_goal 	= parseInt(this.daily_goal.cs_dg_postpaid_even_better);
        this.action_plan_values.postpaid.todays_goal 				= this.action_plan_values.postpaid_basic.todays_goal + this.action_plan_values.postpaid_everyday.todays_goal + this.action_plan_values.postpaid_even_better.todays_goal;
        var postpaid_goal_diff = this.action_plan_values.postpaid.todays_goal - this.action_plan_values.postpaid.daily_goal;
        if (postpaid_goal_diff <= 0) {
            this.action_plan_values.postpaid_basic.todays_goal = this.action_plan_values.postpaid_basic.todays_goal + Math.abs(postpaid_goal_diff) + 1;
            this.action_plan_values.postpaid.todays_goal = this.action_plan_values.postpaid_basic.todays_goal + this.action_plan_values.postpaid_everyday.todays_goal + this.action_plan_values.postpaid_even_better.todays_goal;
        }
        this.action_plan_values.upgrades_basic.todays_goal 			= parseInt(this.daily_goal.cs_dg_upgrades_basic);
        this.action_plan_values.upgrades_everyday.todays_goal 		= parseInt(this.daily_goal.cs_dg_upgrades_everyday);
        this.action_plan_values.upgrades_even_better.todays_goal 	= parseInt(this.daily_goal.cs_dg_upgrades_even_better);
        this.action_plan_values.upgrades.todays_goal 				= this.action_plan_values.upgrades_basic.todays_goal + this.action_plan_values.upgrades_everyday.todays_goal + this.action_plan_values.upgrades_even_better.todays_goal;
        var upgrades_goal_diff = this.action_plan_values.upgrades.todays_goal - this.action_plan_values.upgrades.daily_goal;
        if (upgrades_goal_diff <= 0) {
            this.action_plan_values.upgrades_basic.todays_goal = this.action_plan_values.upgrades_basic.todays_goal + Math.abs(upgrades_goal_diff) + 1;
            this.action_plan_values.upgrades.todays_goal = this.action_plan_values.upgrades_basic.todays_goal + this.action_plan_values.upgrades_everyday.todays_goal + this.action_plan_values.upgrades_even_better.todays_goal;
        }

        this.action_plan_values.hsi.todays_goal 					= this.daily_goal.cs_dg_hsi 					> this.action_plan_values.hsi.daily_goal ? this.daily_goal.cs_dg_postpaid_basic : this.action_plan_values.hsi.daily_goal + 1;
        this.action_plan_values.prepaid.todays_goal 				= this.daily_goal.cs_dg_prepaid 				> this.action_plan_values.prepaid.daily_goal ? this.daily_goal.cs_dg_postpaid_basic : this.action_plan_values.prepaid.daily_goal + 1;
        this.action_plan_values.connected_devices.todays_goal 		= this.daily_goal.cs_dg_connected_devices 		> this.action_plan_values.connected_devices.daily_goal ? this.daily_goal.cs_dg_postpaid_basic : this.action_plan_values.connected_devices.daily_goal + 1;
        // this.action_plan_values.other_volume.todays_goal 		= this.daily_goal.cs_dg_other 					> this.action_plan_values.other_volume.daily_goal ? this.daily_goal.cs_dg_postpaid_basic : this.action_plan_values.other_volume.daily_goal + 1;
        this.action_plan_values.accessories_revenue.todays_goal 	= this.daily_goal.cs_dg_accessories_revenue 	> this.action_plan_values.accessories_revenue.daily_goal ? this.daily_goal.cs_dg_postpaid_basic : this.action_plan_values.accessories_revenue.daily_goal + 1;
        this.action_plan_values.other_revenue.todays_goal 			= this.daily_goal.cs_dg_other_revenue 			> this.action_plan_values.other_revenue.daily_goal ? this.daily_goal.cs_dg_postpaid_basic : this.action_plan_values.other_revenue.daily_goal + 1;
        this.action_plan_values.bir.todays_goal 					= this.daily_goal.cs_dg_bir 					> this.action_plan_values.bir.daily_goal ? this.daily_goal.cs_dg_postpaid_basic : this.action_plan_values.bir.daily_goal + 1;
        this.action_plan_values.high_msrp_accessories.todays_goal 	= this.daily_goal.cs_dg_high_acc 				> this.action_plan_values.high_msrp_accessories.daily_goal ? this.daily_goal.cs_dg_postpaid_basic : this.action_plan_values.high_msrp_accessories.daily_goal + 1;
        // this.action_plan_values.device_trade_ins.todays_goal 	= this.daily_goal.cs_dg_device_trade_ins 		> this.action_plan_values.device_trade_ins.daily_goal ? this.daily_goal.cs_dg_postpaid_basic : this.action_plan_values.device_trade_ins.daily_goal + 1;
    }

    copyDailyGoalValues() {
        // payout estimator 2.0
        this.daily_goal.cs_dg_postpaid_basic		 = this.action_plan_values.postpaid_basic.daily_goal;
        this.daily_goal.cs_dg_postpaid_everyday      = this.action_plan_values.postpaid_everyday.daily_goal;
        this.daily_goal.cs_dg_postpaid_even_better   = this.action_plan_values.postpaid_even_better.daily_goal;
        this.daily_goal.cs_dg_postpaid               = this.action_plan_values.postpaid.daily_goal;
        this.daily_goal.cs_dg_hsi                    = this.action_plan_values.hsi.daily_goal;
        this.daily_goal.cs_dg_prepaid                = this.action_plan_values.prepaid.daily_goal;
        this.daily_goal.cs_dg_connected_devices      = this.action_plan_values.connected_devices.daily_goal;
        // this.daily_goal.cs_dg_other                  = this.action_plan_values.other_volume.daily_goal;
        this.daily_goal.cs_dg_accessories_revenue    = this.action_plan_values.accessories_revenue.daily_goal;
        this.daily_goal.cs_dg_other_revenue          = this.action_plan_values.other_revenue.daily_goal;
        this.daily_goal.cs_dg_bir                    = this.action_plan_values.bir.daily_goal;
        this.daily_goal.cs_dg_upgrades_basic         = this.action_plan_values.upgrades_basic.daily_goal;
        this.daily_goal.cs_dg_upgrades_everyday      = this.action_plan_values.upgrades_everyday.daily_goal;
        this.daily_goal.cs_dg_upgrades_even_better   = this.action_plan_values.upgrades_even_better.daily_goal;
        this.daily_goal.cs_dg_upgrades               = this.action_plan_values.upgrades.daily_goal;
        this.daily_goal.cs_dg_high_msrp_accessories  = this.action_plan_values.high_msrp_accessories.daily_goal;
        // this.daily_goal.cs_dg_device_trade_ins       = this.action_plan_values.device_trade_ins.daily_goal;
    }    

    saveDailyGoal() {
		this.preprocessP2WFieldsToNumber();
		var form_fields = this.fieldService.getFormFields(this.daily_goal_fields, this.daily_goal);
		var reloadDailyGoal = (this.daily_goal.view_ID == 0);
		this.apiService.saveViewItem(this.uscStoreService.view_p2w_daily_goal, this.daily_goal.view_ID, form_fields).subscribe(
			result => {
				if (reloadDailyGoal) {
                    this.getDailyGoal();
                } else {
                    this.uscStoreService.setTodaysGoal(this.daily_goal);                    
                }
			}
		)
		this.preprocessP2WFieldsToCurrency();
	}

    public updateTodaysGoal() {
		this.action_plan_values.postpaid.todays_goal = parseInt(this.action_plan_values.postpaid_basic.todays_goal) + parseInt(this.action_plan_values.postpaid_everyday.todays_goal) + parseInt(this.action_plan_values.postpaid_even_better.todays_goal); 
		// this.action_plan_values.other_volume.todays_goal = parseInt(this.action_plan_values.hsi.todays_goal) + parseInt(this.action_plan_values.prepaid.todays_goal) + parseInt(this.action_plan_values.connected_devices.todays_goal); 
		this.action_plan_values.upgrades.todays_goal = parseInt(this.action_plan_values.upgrades_basic.todays_goal) + parseInt(this.action_plan_values.upgrades_everyday.todays_goal) + parseInt(this.action_plan_values.upgrades_even_better.todays_goal); 

		this.daily_goal.cs_dg_postpaid_basic = this.action_plan_values.postpaid_basic.todays_goal.toString();
		this.daily_goal.cs_dg_postpaid_everyday = this.action_plan_values.postpaid_everyday.todays_goal.toString();
		this.daily_goal.cs_dg_postpaid_even_better = this.action_plan_values.postpaid_even_better.todays_goal.toString();
		this.daily_goal.cs_dg_postpaid = this.action_plan_values.postpaid.todays_goal.toString();
		this.daily_goal.cs_dg_hsi = this.action_plan_values.hsi.todays_goal.toString();
		this.daily_goal.cs_dg_prepaid = this.action_plan_values.prepaid.todays_goal.toString();
		this.daily_goal.cs_dg_connected_devices = this.action_plan_values.connected_devices.todays_goal.toString();
		// this.daily_goal.cs_dg_other = this.action_plan_values.other_volume.todays_goal.toString();
		this.daily_goal.cs_dg_bir = this.action_plan_values.bir.todays_goal.toString();
		this.daily_goal.cs_dg_accessories_revenue = this.action_plan_values.accessories_revenue.todays_goal.toString();
		this.daily_goal.cs_dg_other_revenue = this.action_plan_values.other_revenue.todays_goal.toString();
		this.daily_goal.cs_dg_upgrades_basic = this.action_plan_values.upgrades_basic.todays_goal.toString();
		this.daily_goal.cs_dg_upgrades_everyday = this.action_plan_values.upgrades_everyday.todays_goal.toString();
		this.daily_goal.cs_dg_upgrades_even_better = this.action_plan_values.upgrades_even_better.todays_goal.toString();
		this.daily_goal.cs_dg_upgrades = this.action_plan_values.upgrades.todays_goal.toString();
		this.daily_goal.cs_dg_high_acc = this.action_plan_values.high_msrp_accessories.todays_goal.toString();
		// this.daily_goal.cs_dg_device_trade_ins = this.action_plan_values.device_trade_ins.todays_goal.toString();
	}
    
    onFocusOut(field, bd) {
        if (field && bd) {
			bd[field] = parseInt(bd[field]);
			this.updateTodaysGoal();
		}
		this.preprocessP2WFieldsToCurrency();
		this.saveDailyGoal();
	}

    initializeTodaysGoal() {
        // determine today's goal
        var days_scheduled = parseInt(this.action_plan.cs_days_scheduled);
        var days_worked = this.action_plan.days_worked;
		var days_remaining = this.action_plan.cs_days_scheduled - this.action_plan.days_worked;
        var ap = this.action_plan;
        var dg = this.daily_goal;
        dg.cs_dg_postpaid_basic       = (ap.mtd_postpaid_basic          < parseInt(ap.cs_p2w_postpaid_basic)       / days_scheduled * days_worked) ? Math.ceil((ap.cs_p2w_postpaid_basic       - ap.mtd_postpaid_basic) / days_remaining) : 0;
        dg.cs_dg_postpaid_everyday    = (ap.mtd_postpaid_everyday       < parseInt(ap.cs_p2w_postpaid_everyday)    / days_scheduled * days_worked) ? Math.ceil((ap.cs_p2w_postpaid_everyday    - ap.mtd_postpaid_everyday) / days_remaining) : 0;
        dg.cs_dg_postpaid_even_better = (ap.mtd_postpaid_even_better    < parseInt(ap.cs_p2w_postpaid_even_better) / days_scheduled * days_worked) ? Math.ceil((ap.cs_p2w_postpaid_even_better - ap.mtd_postpaid_even_better) / days_remaining) : 0;
        dg.cs_dg_postpaid             = (ap.mtd_postpaid_handset_volume < parseInt(ap.cs_p2w_postpaid)             / days_scheduled * days_worked) ? Math.ceil((ap.cs_p2w_postpaid             - ap.mtd_postpaid_handset_volume) / days_remaining) : 0;
        dg.cs_dg_hsi                  = (ap.mtd_hsi                     < parseInt(ap.cs_p2w_hsi)                  / days_scheduled * days_worked) ? Math.ceil((ap.cs_p2w_hsi                  - ap.mtd_hsi) / days_remaining) : 0;
        dg.cs_dg_prepaid              = (ap.mtd_prepaid                 < parseInt(ap.cs_p2w_prepaid)              / days_scheduled * days_worked) ? Math.ceil((ap.cs_p2w_prepaid              - ap.mtd_prepaid) / days_remaining) : 0;
        dg.cs_dg_connected_devices    = (ap.mtd_connected_devices       < parseInt(ap.cs_p2w_connected_devices)    / days_scheduled * days_worked) ? Math.ceil((ap.cs_p2w_connected_devices    - ap.mtd_connected_devices) / days_remaining) : 0;
        // dg.cs_dg_other                = (ap.mtd_other_volume            < parseInt(ap.cs_p2w_other)                / days_scheduled * days_worked) ? Math.ceil((ap.cs_p2w_other                - ap.mtd_other_volume) / days_remaining) : 0;
        dg.cs_dg_bir                  = (ap.mtd_bir                     < parseInt(ap.cs_p2w_bir)                  / days_scheduled * days_worked) ? Math.ceil((ap.cs_p2w_bir                  - ap.mtd_bir) / days_remaining) : 0;
        dg.cs_dg_accessories_revenue  = (ap.mtd_accessories_revenue     < parseInt(ap.cs_p2w_accesories_revenue)   / days_scheduled * days_worked) ? Math.ceil((ap.cs_p2w_accessories_revenue  - ap.mtd_accessories_revenue) / days_remaining) : 0;
        dg.cs_dg_other_revenue        = (ap.mtd_other_revenue           < parseInt(ap.cs_p2w_other_revenue)        / days_scheduled * days_worked) ? Math.ceil((ap.cs_p2w_other_revenue        - ap.mtd_other_revenue) / days_remaining) : 0;
        dg.cs_dg_upgrades_basic       = (ap.mtd_upgrades_basic          < parseInt(ap.cs_p2w_upgrades_basic)       / days_scheduled * days_worked) ? Math.ceil((ap.cs_p2w_upgrades_basic       - ap.mtd_upgrades_basic) / days_remaining) : 0;
        dg.cs_dg_upgrades_everyday    = (ap.mtd_upgrades_everyday       < parseInt(ap.cs_p2w_upgrades_everyday)    / days_scheduled * days_worked) ? Math.ceil((ap.cs_p2w_upgrades_everyday    - ap.mtd_upgrades_everyday) / days_remaining) : 0;
        dg.cs_dg_upgrades_even_better = (ap.mtd_upgrades_even_better    < parseInt(ap.cs_p2w_upgrades_even_better) / days_scheduled * days_worked) ? Math.ceil((ap.cs_p2w_upgrades_even_better - ap.mtd_upgrades_even_better) / days_remaining) : 0;
        dg.cs_dg_upgrades             = (ap.mtd_upgrades                < parseInt(ap.cs_p2w_upgrades)             / days_scheduled * days_worked) ? Math.ceil((ap.cs_p2w_upgrades             - ap.mtd_upgrades) / days_remaining) : 0;
        dg.cs_dg_high_acc             = (ap.mtd_high_msrp_accessories   < parseInt(ap.cs_p2w_high_acc)             / days_scheduled * days_worked) ? Math.ceil((ap.cs_p2w_high_acc             - ap.mtd_high_msrp_accessories ) / days_remaining) : 0;
        // dg.cs_dg_device_trade_ins     = (ap.mtd_device_trade_ins        < parseInt(ap.cs_p2w_device_trade_ins)     / days_scheduled * days_worked) ? Math.ceil((ap.cs_p2w_device_trade_ins     - ap.mtd_device_trade_ins ) / days_remaining) : 0;
        this.daily_goal.cs_dg_revenue = this.daily_goal.cs_dg_accessories_revenue + this.daily_goal.cs_dg_other_revenue;

        // set minimum today's goal (payout estimator 2.0)
		if (this.daily_goal.cs_dg_postpaid_basic < this.pp_basic_p2w_daily_goal)                this.daily_goal.cs_dg_postpaid_basic = Math.ceil(this.pp_basic_p2w_daily_goal);
		if (this.daily_goal.cs_dg_postpaid_everyday < this.pp_everyday_p2w_daily_goal)          this.daily_goal.cs_dg_postpaid_everyday = Math.ceil(this.pp_everyday_p2w_daily_goal);
		if (this.daily_goal.cs_dg_postpaid_even_better < this.pp_even_better_p2w_daily_goal)    this.daily_goal.cs_dg_postpaid_even_better = Math.ceil(this.pp_even_better_p2w_daily_goal);
        this.daily_goal.cs_dg_postpaid = this.daily_goal.cs_dg_postpaid_basic + this.daily_goal.cs_dg_postpaid_everyday + this.daily_goal.cs_dg_postpaid_even_better;
        //if (this.daily_goal.cs_dg_postpaid < this.pp_p2w_daily_goal)                            this.daily_goal.cs_dg_postpaid = Math.ceil(this.pp_p2w_daily_goal);
		if (this.daily_goal.cs_dg_hsi < this.hsi_p2w_daily_goal)                                this.daily_goal.cs_dg_hsi = Math.ceil(this.hsi_p2w_daily_goal);
		if (this.daily_goal.cs_dg_prepaid < this.prepaid_p2w_daily_goal)                        this.daily_goal.cs_dg_prepaid = Math.ceil(this.prepaid_p2w_daily_goal);
		if (this.daily_goal.cs_dg_connected_devices < this.cd_p2w_daily_goal)                   this.daily_goal.cs_dg_connected_devices = Math.ceil(this.cd_p2w_daily_goal);
        this.daily_goal.cs_dg_other = this.daily_goal.cs_dg_hsi + this.daily_goal.cs_dg_prepaid + this.daily_goal.cs_dg_connected_devices;
        //if (this.daily_goal.cs_dg_other < this.other_p2w_daily_goal)                            this.daily_goal.cs_dg_other = Math.ceil(this.other_p2w_daily_goal);
        if (this.daily_goal.cs_dg_revenue < this.revenue_p2w_daily_goal)                        this.daily_goal.cs_dg_revenue = Math.ceil(this.revenue_p2w_daily_goal);
        if (this.daily_goal.cs_dg_accessories_revenue < this.ar_p2w_daily_goal)                 this.daily_goal.cs_dg_accessories_revenue = Math.ceil(this.ar_p2w_daily_goal);
        if (this.daily_goal.cs_dg_other_revenue < this.or_p2w_daily_goal)                       this.daily_goal.cs_dg_other_revenue = Math.ceil(this.or_p2w_daily_goal);
        if (this.daily_goal.cs_dg_bir < this.bir_p2w_daily_goal)                                this.daily_goal.cs_dg_bir = Math.ceil(this.bir_p2w_daily_goal);
		if (this.daily_goal.cs_dg_upgrades_basic < this.ug_basic_p2w_daily_goal)                this.daily_goal.cs_dg_upgrades_basic = Math.ceil(this.ug_basic_p2w_daily_goal);
		if (this.daily_goal.cs_dg_upgrades_everyday < this.ug_everyday_p2w_daily_goal)          this.daily_goal.cs_dg_upgrades_everyday = Math.ceil(this.ug_everyday_p2w_daily_goal);
		if (this.daily_goal.cs_dg_upgrades_even_better < this.ug_even_better_p2w_daily_goal)    this.daily_goal.cs_dg_upgrades_even_better = Math.ceil(this.ug_even_better_p2w_daily_goal);
        this.daily_goal.cs_dg_upgrades = this.daily_goal.cs_dg_upgrades_basic + this.daily_goal.cs_dg_upgrades_everyday + this.daily_goal.cs_dg_upgrades_even_better;
        //if (this.daily_goal.cs_dg_upgrades < this.upgrades_p2w_daily_goal)                      this.daily_goal.cs_dg_postpaid = Math.ceil(this.pp_p2w_daily_goal);
        if (this.daily_goal.cs_dg_high_acc < this.hma_p2w_daily_goal)                           this.daily_goal.cs_dg_high_acc = Math.ceil(this.hma_p2w_daily_goal);
        // if (this.daily_goal.cs_dg_device_trade_ins < this.dti_p2w_daily_goal)                   this.daily_goal.cs_dg_device_trade_ins = Math.ceil(this.dti_p2w_daily_goal);
    }

    preprocessP2WFieldsToCurrency() {
		this.preprocessP2WFields(true);
	}

	preprocessP2WFieldsToNumber() {
		this.preprocessP2WFields(false);
	}

	preprocessP2WFields(bToCurrency:boolean) {
		// prefix $ to all p2w goals
		for (const p in this.action_plan) {
			if (p.indexOf('cs_dg_revenue') >= 0 && p.indexOf('quota') < 0) {
				var value = this.action_plan[p];
				value = value ? value.toString() : "$0";
				if (value && value.indexOf('$') >= 0) {
					this.action_plan[p] = parseInt(value.replace('$', ''));
				}
				if (bToCurrency) {
					this.action_plan[p] = '$' + this.action_plan[p].toString();
				} 
			}
		}

		for (const p in this.daily_goal) {
			if (p.indexOf('_revenue') >= 0 && p.indexOf('quota') < 0) {
				var value = this.daily_goal[p];
				value = value ? value.toString() : "$0";
				if (value && value.indexOf('$') >= 0) {
					this.daily_goal[p] = parseInt(value.replace('$', ''));
				}
				if (bToCurrency) {
					this.daily_goal[p] = '$' + this.daily_goal[p].toString();
				} 
			}
		}
	}
    
	getBusinessDriverDesc(field) {
		return this.uscStoreService.getBusinessDriverDesc(field);
	}

    validateDailyGoal() : any[] {
		var errors = [];
		var bValid = true;
		// all p2w goals cannot be empty and must be more than the base quota
		if (this.uscStoreService.isUSCellAgent() && 
            !((this.action_plan_values.postpaid.month_goals == 0 || parseInt(this.daily_goal.cs_dg_postpaid) >= parseInt(this.pp_p2w_daily_goal)) &&
            (this.action_plan_values.hsi.month_goals == 0 || parseInt(this.daily_goal.cs_dg_hsi) >= parseInt(this.hsi_p2w_daily_goal)) &&
            (this.action_plan_values.prepaid.month_goals == 0 || parseInt(this.daily_goal.cs_dg_prepaid) >= parseInt(this.prepaid_p2w_daily_goal)) &&
            (this.action_plan_values.connected_devices.month_goals == 0 || parseInt(this.daily_goal.cs_dg_connected_devices) >= parseInt(this.cd_p2w_daily_goal)) &&
            (this.action_plan_values.accessories_revenue.month_goals == 0 || parseInt(this.daily_goal.cs_dg_accessories_revenue) >= parseInt(this.ar_p2w_daily_goal)) &&
            (this.action_plan_values.bir.month_goals == 0 || parseInt(this.daily_goal.cs_dg_bir) >= parseInt(this.bir_p2w_daily_goal)) &&
            (this.action_plan_values.upgrades.month_goals == 0 || parseInt(this.daily_goal.cs_dg_upgrades) >= parseInt(this.upgrades_p2w_daily_goal)))
        ) {
			errors.push("Today's goals must be greater or equal to P2W Daily Goals");
			bValid = false;
		} else if (!this.uscStoreService.isUSCellAgent() && 
            !(parseInt(this.daily_goal.cs_dg_postpaid) >= parseInt(this.pp_p2w_daily_goal) &&
            // parseInt(this.daily_goal.cs_dg_other) >= parseInt(this.other_p2w_daily_goal) &&
            // parseInt(this.daily_goal.cs_dg_revenue) >= parseInt(this.revenue_p2w_daily_goal) &&
            parseInt(this.daily_goal.cs_dg_prepaid) >= parseInt(this.prepaid_p2w_daily_goal) &&
            parseInt(this.daily_goal.cs_dg_connected_devices) >= parseInt(this.cd_p2w_daily_goal) &&
            parseInt(this.daily_goal.cs_dg_hsi) >= parseInt(this.hsi_p2w_daily_goal) &&
            parseInt(this.daily_goal.cs_dg_accessories_revenue) >= parseInt(this.ar_p2w_daily_goal) &&
            parseInt(this.daily_goal.cs_dg_other_revenue) >= parseInt(this.or_p2w_daily_goal) &&
            parseInt(this.daily_goal.cs_dg_bir) >= parseInt(this.bir_p2w_daily_goal) &&
            parseInt(this.daily_goal.cs_dg_upgrades) >= parseInt(this.upgrades_p2w_daily_goal) &&
            parseInt(this.daily_goal.cs_dg_high_acc) >= parseInt(this.hma_p2w_daily_goal))
            // parseInt(this.daily_goal.cs_dg_high_acc) >= parseInt(this.hma_p2w_daily_goal) &&
            // parseInt(this.daily_goal.cs_dg_device_trade_ins) >= parseInt(this.dti_p2w_daily_goal))
        ) {
            errors.push("Today's goals must be greater or equal to P2W Daily Goals");
            bValid = false;
        }
		return errors;
	}

    submitGoal() {
        this.preprocessP2WFieldsToNumber();
        if (this.daily_goal.view_ID == 0)  {
            this.daily_goal.cs_status = this.uscStoreService.daily_goal_status_submitted;
            this.saveDailyGoal();
        } else {
            var errors = this.validateDailyGoal();
            if (errors.length > 0) {
                this.daily_goal.cs_dg_revenue = this.daily_goal.cs_dg_accessories_revenue + this.daily_goal.cs_dg_other_revenue;
                this.modalService.openContent(
                    UscDialogComponent,
                    { dlgType: this.uscStoreService.dialog_type_ok_prompt, msg_config: { msg: errors[0] }},
                    { size: "lg", backdrop: 'static', keyboard: false }
                ).result.then(
                    (result) => { this.preprocessP2WFieldsToCurrency() },
                    (reason) => { }
                );        
            } else {
                var params = { }
                this.is_saving_todays_goal = true;
                this.apiService.processActionOnViewItem(this.uscStoreService.view_p2w_daily_goal, this.daily_goal.view_ID, this.uscStoreService.action_daily_goal_submission, params).subscribe(
                    result => {
                        this.getDailyGoal();
                    }
                )
            }
        }
    }

    
	getCurrency(value:string) {
		if (value.indexOf('$') >= 0) value = value.replace('$', '');
		return this.translatorService.toCurrency(value);
	}

    //#region Payout Estimator 2.0
	public isColumnVisible(column) {
		switch (column) {
			default: 
				return true;
		}
	}

	// public getColumnHeader(column) {
	// 	var column_headers = {
	// 		best: "Highest Achieving Month's Results",
	// 		avg: "Average Month's Results (90 Days)",
	// 		quota: "Quota",
	// 		monthly_goal: "P2W Monthly Goal",
	// 		daily_goal: "P2W Daily Goal",
	// 		mtd_actual: this.isPrevMonthActionPlan ? "Actual Sales" : "MTD Actual",
	// 		pacing_to_quota: this.isPrevMonthActionPlan ? '% Sales vs Quota' : 'MTD Pacing to Quota',
	// 		pacing_to_goal: this.isPrevMonthActionPlan ? '% Sales vs P2W Goal' : 'MTD Pacing to P2W Goal',
	// 	}
	// 	return column_headers[column];
	// }

	public getCellValue(column, bd) {
		switch (column) {
			case "best":
			case "avg":
			case "quota":
				if (this.action_plan_values[bd] && this.action_plan_values[bd][column]) return this.action_plan_values[bd][column];
			case "daily_goal":
				if (this.action_plan_values[bd] && this.action_plan_values[bd][column]) return this.action_plan_values[bd][column].toFixed(0);
			case "pacing_to_quota":
			case "pacing_to_goal":
				if (this.action_plan_values[bd] && this.action_plan_values[bd][column]) return this.translatorService.toPercentage(this.action_plan_values[bd][column]);
			case "mtd_actual":
				break;
		}
	}

	public getCellValueStyle(bd, column) {
		var driver_components = [
			'postpaid_basic',
			'postpaid_everyday',
			'postpaid_even_better',
			'upgrades_basic',
			'upgrades_everyday',
			'upgrades_even_better',
			'hsi',
			'prepaid',
			'conntected_devices',
		];
		var style = {};
		if (bd[column] == null) style = { "background-color": "#2f75b5" };
		return style;
	}

	public showBusinessDriverToolTip(bd) {
		return this.uscStoreService.getBusinessDriverDesc(bd.driver) != null;
	}

	public getBusinessDriverToolTip(bd) {
		return this.uscStoreService.getBusinessDriverDesc(bd.driver);
	}
    //#endregion
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-todays-goal/usc-todays-goal.component.ts